import { Monitor } from "lucide-react";
import { useEffect, useState } from "react";

/** Shows a dignified gate when viewport width < 1024px. */
export default function MobileGate({ children }) {
  const [tooNarrow, setTooNarrow] = useState(false);

  useEffect(() => {
    const check = () => setTooNarrow(window.innerWidth < 1024);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!tooNarrow) return children;

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "var(--bg-app)" }}
      data-testid="mobile-gate"
    >
      <div
        className="max-w-sm text-center rounded-xl bg-white border border-slate-200 p-8"
        style={{ boxShadow: "var(--shadow-md)" }}
      >
        <div className="inline-flex h-10 w-10 rounded-md bg-slate-900 text-white items-center justify-center mb-4">
          <Monitor className="h-5 w-5" />
        </div>
        <h1
          className="text-xl font-semibold"
          style={{ color: "var(--text-primary)" }}
        >
          TechQuote richiede uno schermo più ampio
        </h1>
        <p
          className="mt-2 text-sm"
          style={{ color: "var(--text-secondary)" }}
        >
          L&apos;app è pensata per lavorare su desktop a tre colonne.
          Accedi da un computer con schermo da 1280px in su.
        </p>
      </div>
    </div>
  );
}
